export const MAPPING_MACHINE_TYPE_BY_MATERIAL_NUMBER = {
  '1.533-000.1': 'KIRA B 50',
  '1.533-001.0': 'KIRA B 50',
  '1.533-002.0': 'KIRA B 50'
};

export const getMachineType = (materialNumber = '') =>
  MAPPING_MACHINE_TYPE_BY_MATERIAL_NUMBER[materialNumber] || '';
